export default __webpack_public_path__ + "static/media/saint-pierre-sur-dives11.d5a19469.jpg";